const datePickTypes = ["year", "month", "date", "dates", "week", "datetime", "datetimerange", "daterange", "monthrange"];
const WEEK_DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
export { WEEK_DAYS, datePickTypes };